import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useDiscadoraPause } from "@/hooks/useDiscadoraPause";
import { abrirMesaDiscadora } from "@/lib/discadoraMesa";
import { ehPausaDoSucesso, restantePausaSucesso, formatarMmSs } from "@/lib/discadoraPausaSucesso";

export function FloatingDiscadoraButton() {
  const location = useLocation();
  const { isPaused, currentMotivo, pausedSince, ramal } = useDiscadoraPause();
  const [tempoDecorrido, setTempoDecorrido] = useState("00:00");

  // Log de debug
  console.log('[FloatingButton] Estado:', {
    isPaused,
    currentMotivo,
    pausedSince,
    ramal,
    pathname: location.pathname
  })

  // Atualizar tempo decorrido a cada segundo
  useEffect(() => {
    if (!isPaused || !pausedSince) {
      setTempoDecorrido("00:00");
      return;
    }

    try {
      // Pausa do Sucesso conta REGRESSIVO: o servidor despausa ao zerar (5 min).
      const regressivo = ehPausaDoSucesso(currentMotivo);
      const calcularTempo = () => {
        if (regressivo) return `volta em ${formatarMmSs(restantePausaSucesso(pausedSince))}`;
        const agora = new Date();
        const diff = Math.floor((agora.getTime() - pausedSince.getTime()) / 1000);
        const minutos = Math.floor(diff / 60);
        const segundos = diff % 60;
        return `${String(minutos).padStart(2, "0")}:${String(segundos).padStart(2, "0")}`;
      };

      setTempoDecorrido(calcularTempo());
      const interval = setInterval(() => {
        setTempoDecorrido(calcularTempo());
      }, 1000);

      return () => clearInterval(interval);
    } catch (error) {
      console.error('[FloatingButton] Erro ao calcular tempo:', error)
      setTempoDecorrido("--:--")
    }
  }, [isPaused, pausedSince, currentMotivo]);

  // Não mostrar se:
  // - Não está pausado
  // - Ramal não configurado
  const shouldShow = isPaused && ramal !== null;

  console.log('[FloatingButton] shouldShow:', shouldShow)

  if (!shouldShow) return null;

  try {
    return (
      <div className="fixed top-3.5 right-80 z-50 hidden md:flex">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                onClick={abrirMesaDiscadora}
                className="h-9 rounded-lg border border-primary/30 bg-primary px-3 shadow-lg transition-colors hover:bg-primary/90 flex items-center gap-2"
              >
                <Phone className="h-4 w-4 text-white" />
                <span className="text-xs font-mono font-bold text-white">
                  {tempoDecorrido}
                </span>
                <span className="text-white/60">•</span>
                <span className="text-xs text-white/90 max-w-[100px] truncate">
                  {currentMotivo || "Pausado"}
                </span>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom" className="text-xs">
              <p>Abrir a Mesa da Discadora</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  } catch (error) {
    console.error('[FloatingButton] Erro ao renderizar:', error)
    return null
  }
}
